// extracted by mini-css-extract-plugin
export var modal = "_ch-0";